deterministicDecirc